// Single source of truth for the "Last updated" date shown on legal
// pages. Change here to update Privacy / Terms / Security at once.
export const LEGAL_LAST_UPDATED = "12 June 2026";
